import { useEffect, useState } from 'react';
import * as Actions from 'flex/Actions';
import { useAppSelector } from 'flex/utils';
import { findApplicationAgs, findTakeHasNewScoreLineItem } from './Helper';
import { AppTemplateAuthTypeEnum } from 'constants/GlobalConfig';

type Student = {
    uuid: string,
    name: string
}

const INIT_STATE: AppStatusModal.StudentView = {
    student: {
        uuid: '',
        name: '',
    },
    loading: false,
    applications: [],
    pagination: {
        total: 0,
        pageSize: 5,
        current: 1,
        position: ['topRight', 'bottomRight'],
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15'],
    }
};

export const useStudentViewData = (student: Student) => {
    const [studentView, setStudentView] = useState<AppStatusModal.StudentView>({ ...INIT_STATE });
    const appsCategoryResult = useAppSelector(state => state.appsCategoryResultConnection);

    useEffect(() => {
        const {
            meta: { status },
            payload: { result: payloadResult },
        } = appsCategoryResult;

        switch (status) {
            case Actions.statusEnum.REQUEST:
            case Actions.statusEnum.LOADING: {
                break;
            }
            case Actions.statusEnum.SUCCESS: {
                const total = payloadResult?.item_count ? payloadResult?.item_count : 0;
                const applications = payloadResult
                    ? payloadResult.items.find(item => item.uuid === student.uuid)?.applications
                    : undefined;

                const applicationAgs = findApplicationAgs(applications);

                const generatedApplications = applicationAgs
                    ? applicationAgs.map((app) => {
                        let children = [];
                        const takeHasNewScoreLineItem = findTakeHasNewScoreLineItem(app);

                        if (!takeHasNewScoreLineItem && app?.line_items) {
                            children = app.line_items?.map((lineItem: any) => ({
                                uuid: lineItem.uuid,
                                title: lineItem.label,
                                scoreGiven: undefined,
                                scoreMaximum: lineItem!.score_maximum,
                                activityProgress: undefined,
                                createdAt: undefined,
                                updatedAt: undefined,
                                comment: undefined,
                                gradingProgress: undefined,
                                scoringUserId: undefined,
                                startedAt: undefined,
                                submittedAt: undefined,
                            }));
                        } else {
                            children =
                                takeHasNewScoreLineItem?.line_items &&
                                takeHasNewScoreLineItem.line_items.map((lineItem: any) => {
                                    const scoreLineItem = lineItem.score_line_items?.[0];
                                    return {
                                        uuid: lineItem.uuid,
                                        title: lineItem.label ?? "",
                                        scoreGiven: scoreLineItem?.score_given,
                                        scoreMaximum: scoreLineItem?.score_maximum,
                                        activityProgress: scoreLineItem?.activity_progress,
                                        createdAt: scoreLineItem?.created_at,
                                        updatedAt: scoreLineItem?.updated_at,
                                        comment: scoreLineItem?.comment,
                                        gradingProgress: scoreLineItem?.grading_progress,
                                        scoringUserId: scoreLineItem?.scoring_user_id,
                                        startedAt: scoreLineItem?.started_at,
                                        submittedAt: scoreLineItem?.submitted_at,
                                    };
                                });
                        }

                        return {
                            title: app.title,
                            uuid: app.uuid,
                            resultUrl: app.result_url ?? '',
                            activityProgress: undefined,
                            createdAt: undefined,
                            updatedAt: undefined,
                            comment: undefined,
                            gradingProgress: undefined,
                            scoreGiven: undefined,
                            scoreMaximum: undefined,
                            scoringUserId: undefined,
                            startedAt: undefined,
                            submittedAt: undefined,
                            children: children,
                            isApp: true,
                        }
                    })
                    : [];
                    

                setStudentView({
                    ...studentView,
                    pagination: {
                        ...studentView.pagination,
                        total: total
                    },
                    student: student,
                    loading: false,
                    applications: generatedApplications
                });
                break;
            }
            case Actions.statusEnum.FAILURE:
            case Actions.statusEnum.ERROR: {
                setStudentView({ ...INIT_STATE });
                break;
            }
            default: {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const _: never = status;
            }
        }
        // appsCategoryResultのみ監視対象としたいため
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appsCategoryResult]);

    return [studentView] as const;
};